import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { DadosFormList } from "./dados-form";
import { HomeService } from "../home.service";

@Injectable({ providedIn: "root" })
export class DadosFormStore {
  private readonly _captacao = new BehaviorSubject<DadosFormList[]>([]);
  readonly product$ = this._captacao.asObservable();

  private readonly _productsPageIndex = new BehaviorSubject<string>("0");
  readonly productsPageIndex$ = this._productsPageIndex.asObservable();

  private readonly _productsSearch = new BehaviorSubject<string>("");
  readonly productsSearch$ = this._productsSearch.asObservable();

  private readonly _productsPageSize = new BehaviorSubject<string>("");
  readonly productsPageSize$ = this._productsPageSize.asObservable();

  private readonly _productsLenght = new BehaviorSubject<number>(0);
  readonly productsLenght$ = this._productsLenght.asObservable();

  constructor(private dadosService: HomeService) {}

  initState(
    pageIndex: string,
    pageSize: string,
    search: string,
    lenght: number
  ) {
    if (this.pageSearch == "") {
      this.pageSearch = search;
    }

    // if(this.captacao.length === 0){
    this.pageIndex = pageIndex;
    this.pageSize = !this.pageSize ? pageSize : this.pageSize;
    this.dadosService
      .findAll(this.pageSize, this.pageIndex, this.pageSearch)
      .subscribe((res) => {
        this.pageLenght = res.total;
        this.captacao = res.results;
      });
    // }
  }

  get captacao(): DadosFormList[] {
    return this._captacao.getValue();
  }

  set captacao(val: DadosFormList[]) {
    this._captacao.next(val);
  }

  get pageIndex(): string {
    return this._productsPageIndex.getValue();
  }

  set pageSize(page: string) {
    this._productsPageSize.next(page);
  }

  get pageSize(): string {
    return this._productsPageSize.getValue();
  }

  set pageIndex(page: string) {
    this._productsPageIndex.next(page);
  }

  get pageLenght(): any {
    return this._productsLenght.getValue();
  }

  set pageLenght(lenght: any) {
    this._productsLenght.next(lenght);
  }

  get pageSearch(): string {
    return this._productsSearch.getValue();
  }

  set pageSearch(busca: string) {
    this._productsSearch.next(busca);
  }

  addCaptacao(product: DadosFormList) {
    if (this.captacao.length >= parseInt(this.pageSize)) {
      this.captacao.pop();
    }
    this.captacao = [product, ...this.captacao];
    this.pageLenght = parseInt(this.pageLenght) + 1;
  }

  updateCaptacao(product: DadosFormList) {
    this.captacao.forEach((element, index) => {
      if (element.doador.idDoador == product.doador.idDoador) {
        this.captacao[index] = product;
      }
    });
  }

  // removeProduct(codigo:string){
  //     this.doadores = this.doadores.filter(product => product.codigo !== codigo);
  //     this.pageLenght = this.pageLenght - 1;
  // }
}
